import { render, staticRenderFns } from "./dinnerdetail.vue?vue&type=template&id=6c4155fb&scoped=true"
import script from "./dinnerdetail.vue?vue&type=script&lang=js"
export * from "./dinnerdetail.vue?vue&type=script&lang=js"
import style0 from "./dinnerdetail.vue?vue&type=style&index=0&id=6c4155fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4155fb",
  null
  
)

export default component.exports